import { useEffect } from "react";
import { observer } from "mobx-react";
import { useNavigate, useLocation } from "react-router";
import authStore from "../stores/authStore";

const LoginRedirect = observer(() => {
  const navigate = useNavigate();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const token = params.get("promo_period_renew_token");

  useEffect(() => {
    if (!token) {
      navigate("/");
      return;
    }

    if (authStore.isLoggedIn) {
      authStore.logout(false);
    }

    navigate(`/?promo_period_renew_token=${encodeURIComponent(token)}`, { replace: true });
    window.location.reload();
  }, [token, navigate]);

  return null;
});

export default LoginRedirect;